import {FinanceState} from "@/store/finance/types";
import {Module} from "vuex";
import {RootState} from "@/store/types";
import {getters} from "@/store/finance/getters";
import {actions} from "@/store/finance/actions";
import {mutations} from "@/store/finance/mutations";

export const state: FinanceState = {
  balances: [],
  overdrafts: []
}

export const finance: Module<FinanceState, RootState> = {
  state,
  getters,
  actions,
  mutations
}